import React, { useEffect } from "react";
import { Link } from "react-router-dom"; // ✅ import Link
import homeCleaningImg from "../img/HomeCleaning.png";
import kitchenCleaningImg from "../img/KitchenCleaning.png";
import bathroomCleaningImg from "../img/BathroomCleaning.png";
import "../css/home.css";
import { FaPhoneAlt } from "react-icons/fa";

function Service() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('show');
          }
        });
      },
      { threshold: 0.3 }
    );

    const elements = document.querySelectorAll('.fade-up');
    elements.forEach(el => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section className="services-section py-5">
      <div className="container">
        {/* Section Heading */}
        <div className="text-center mb-5 fade-up">
          <h6 className="section-tag">WHAT WE OFFER</h6>
          <hr className="center-hr " />
          <h2 className="section-title">Our Professional Services</h2>
          <p className="section-desc">
            We provide high-quality, reliable, and affordable cleaning solutions
          </p>
        </div>

        <div className="row">
          {/* Home Cleaning */}
          <div className="col-md-4 mb-4 fade-up">
            <div className="service-card">
              <img src={homeCleaningImg} alt="Home Cleaning" />
              <div className="service-content">
                <h5>Home Cleaning</h5>
                <p>Complete deep cleaning for a fresh and healthy home.</p>
                <Link  to="/contact"  className="service-btn d-inline-flex align-items-center gap-2">Contact Us
                  <FaPhoneAlt />
                </Link>
              </div>
            </div>
          </div>

          {/* Kitchen Cleaning */}
          <div className="col-md-4 mb-4 fade-up">
            <div className="service-card">
              <img src={kitchenCleaningImg} alt="Kitchen Cleaning" />
              <div className="service-content">
                <h5>Kitchen Cleaning</h5>
                <p>Hygienic and grease-free kitchen cleaning service.</p>
                <Link  to="/contact"  className="service-btn d-inline-flex align-items-center gap-2">Contact Us
                  <FaPhoneAlt />
                </Link>
              </div>
            </div>
          </div>

          {/* Bathroom Cleaning */}
          <div className="col-md-4 mb-4 fade-up">
            <div className="service-card">
              <img src={bathroomCleaningImg} alt="Bathroom Cleaning" />
              <div className="service-content">
                <h5>Bathroom Cleaning</h5>
                <p>Sanitized and sparkling clean bathrooms guaranteed.</p>
                 <Link  to="/contact"  className="service-btn d-inline-flex align-items-center gap-2">Contact Us
                  <FaPhoneAlt />
                </Link>
              </div>
            </div>
          </div>
          
        </div>

           {/* See All Projects Button */}
                <div className="text-center mt-4 fade-up">
                  <Link to="/services" className="btn btn-all-projects btn-lg">
                    Services We Provide
                  </Link>
                </div>
        
      </div>
    </section>
  );
}

export default Service;
